import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Nav.css'

function MainNav() {
  return (
    <Navbar expand="lg" variant='dark' className="nav bg-body-tertiary">
      <Container>
        {/* REPLACE WITH LOCAL IMAGE */}
        <Nav.Link><img src="https://ctlcomms.com/wp-content/uploads/2021/05/Asset-2@4x.png" alt="" /></Nav.Link> 
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="#home">Link 1</Nav.Link>
            <Nav.Link href="#link">Link 2</Nav.Link>
            <Nav.Link href="#link">Link 3</Nav.Link>
            <Nav.Link href="#link">Link 4</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default MainNav;